import { useEffect, useState } from 'react';
import { Serial, SnaiV } from 'Models';
import { SerialService, SnaiVService } from 'Services';
import { catchError, finalize, tap } from "rxjs/operators";
import { forkJoin } from "rxjs";
import { useSnackbar } from "notistack";

export function useSnaiV(projectId:number){
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [snaiV, setSnaiV] = useState<SnaiV[]>([]);
    const [serials, setSerials] = useState<Serial[]>([]);
    const {enqueueSnackbar} = useSnackbar();
    
    useEffect(() => {
        if (projectId > 0 ) {
        const observable = forkJoin({
            snaiV: SnaiVService.GetSnaiVByProjectId(projectId),
            serials: SerialService.GetSerials()
        });
        observable.pipe(
            tap(response => {
                setSnaiV(response.snaiV);
                setSerials(response.serials);
            }),
            catchError(error => {
                enqueueSnackbar(error.toString(), {variant: 'error'});
                return Promise.reject(error);
            }),
            finalize(() => setIsLoading(false))
        ).subscribe();
        } else {
            setIsLoading(false);
        }
    }, [projectId,enqueueSnackbar]);

    return {snaiV, setSnaiV, serials, setSerials, isLoading}
}